<template>
    <div>
        <div class="flex justify-center">
            <div class=" flex items-center ">
                <router-link v-if="backLink" :to="backLink" class="mr3 no-underline">
                    <img src="@/assets/img/button_back.svg">   
                </router-link>
                <BlackButton class="w5 mr3">See All</BlackButton>

                <TooliabaButton @click="updateListing" class="w5 mr3">Save</TooliabaButton>


                <router-link v-if="forwardLink" :to="forwardLink" class="no-underline">
                    <img src="@/assets/img/button_forward.svg">
                </router-link>
                <img src="@/assets/img/button_forward.svg">
            </div>
        </div>

        <!-- save listing notification -->
        <OverlayWarning :showWarning="showWarning">
            <ListingUpdated @cancel="showWarning = false"/>
        </OverlayWarning>
    </div>

</template>

<script>
import BlackButton from '@/components/buttons/BlackButton.vue';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import OverlayWarning from '@/components/global/OverlayWarning.vue';
import ListingUpdated from '@/components/editListing/popups/ListingUpdated.vue';

export default {
    data() {
        return {
            showWarning: false
        };
    },
    props: {
        back: {
            type: String
        },
        forward: {
            type: String
        },
        backLink: {
            type: String
        },
        forwardLink: {
            type: String
        }
    },
    components: {
        BlackButton,
        TooliabaButton,
        OverlayWarning,
        ListingUpdated
    },
    methods: {
        updateListing() {
            this.showWarning = true;
        }
    }
};
</script>
